import { ReactNode, useRef } from 'react';
import styled, { css } from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as SS from 'styled-system';

import { textStyles as styles } from 'theme';

import { AnalyticsData } from './AnalyticsData';
import { StyleProps } from './StyleProps';
import { cleanTextProps } from './cleanTextProps';
import { useLinksHaveUTMParams } from './useLinksHaveUTMParams';
import { useTrackLinks } from './useTrackLinks';

const styledSystem = css`
  ${SS.space}
  ${SS.overflow}
  ${SS.color}
  ${SS.opacity}
  ${SS.fontFamily}
  ${SS.fontSize}
  ${SS.fontWeight}
  ${SS.fontStyle}
  ${SS.letterSpacing}
  ${SS.textAlign}
  ${SS.lineHeight}
  ${SS.borders}
  ${SS.borderColor}
  ${SS.display}
  ${SS.verticalAlign}
  ${SS.shadow}
`;

type Props = {
  tag?: string;
  styleAs?: string;
  children?: ReactNode;
  analyticsData?: AnalyticsData;
  dangerouslySetInnerHTML?: { __html: string };
  className?: string;
  title?: string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  as?: any;
};

export const Text = styled(
  ({ tag = 'div', styleAs, analyticsData, ...props }: Props) => {
    const ref = useRef<HTMLElement | null>();
    // @ts-expect-error TS(2322): Type 'MutableRefObject<HTMLElement | null | undefi... Remove this comment to see the full error message
    useTrackLinks({ ref, analyticsData });
    // @ts-expect-error TS(2322): Type 'MutableRefObject<HTMLElement | null | undefi... Remove this comment to see the full error message
    useLinksHaveUTMParams({ ref });

    const otherProps = cleanTextProps(props);

    const Tag = tag;
    // TODO: Fix this the next time the file is edited.
    // @ts-expect-error TS(2322): Type '{ ref: MutableRefObject<HTMLElement | null |... Remove this comment to see the full error message
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <Tag ref={ref} {...otherProps} />;
  },
)
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  .attrs<any>(
    ({
      textOverflow,
      textTransform,
      textDecoration,
      whiteSpace,
      textShadow,
    }) => ({
      style: {
        textOverflow,
        textTransform,
        textDecoration,
        whiteSpace,
        textShadow,
      },
    }),
  )<StyleProps>`
  ${(props) =>
    props.styleAs &&
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    styles[props.styleAs] &&
    `
    
    ${
      // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      styles[props.styleAs]
    }
  `}
  ${
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (props: any) =>
      props.$lineClamp &&
      `
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-line-clamp: ${props.$lineClamp};
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
`
  }
  ${styledSystem}
`;
